import gql from 'graphql-tag';

export default gql`
query adminProductListAd($id: ID!) {
    adminProductListAd(id: $id) {
        id
        name
        banner_url
        type
        product {
            id
            name
        }
        image_url_desktop
        image_url_mobile
        urls {
            url
            position
        }
        is_active
        active_from
        active_to
    }
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminProductListAd.ts